import { MBox, MText } from '../../../components/Monetize';

interface BillGroupDetailsCardProps {
  label: string;
  value: string;
  valueColor?: string;
}

export const BillGroupDetailsCard = ({
  label,
  value,
  valueColor,
}: BillGroupDetailsCardProps) => {
  return (
    <MBox>
      <MText fontWeight="400" fontSize="md">
        {label}
      </MText>
      <MText fontWeight="700" fontSize="2.5xl" color={valueColor}>
        {value}
      </MText>
    </MBox>
  );
};
